// extracted by mini-css-extract-plugin
export var box = "AnchorMenu-module--box--97704";
export var box_md = "AnchorMenu-module--box_md--13a67";
export var box_xmd = "AnchorMenu-module--box_xmd--cd99f";
export var box_flex = "AnchorMenu-module--box_flex--22726";
export var box_lg = "AnchorMenu-module--box_lg--e44fe";
export var box_sm = "AnchorMenu-module--box_sm--eb64f";
export var box_outer = "AnchorMenu-module--box_outer--76be6";
export var box_whiteBg = "AnchorMenu-module--box_white-bg--72504";
export var box_noMarginBottom = "AnchorMenu-module--box_no-margin-bottom--12e7b";
export var box_noPadding = "AnchorMenu-module--box_no-padding--95636";
export var box_outerGray = "AnchorMenu-module--box_outer-gray--9c3ae";
export var box_dark = "AnchorMenu-module--box_dark--0fbe5";
export var box_zIndex = "AnchorMenu-module--box_z-index--a5d18";
export var box_zIndex6 = "AnchorMenu-module--box_z-index-6--58c8c";
export var box_eventsWithLine = "AnchorMenu-module--box_events-with-line--3b424";
export var box_featuresAo = "AnchorMenu-module--box_features-ao--66573";
export var box_verticalPaddings = "AnchorMenu-module--box_vertical-paddings--33e4b";
export var clearP = "AnchorMenu-module--clearP--b240b";
export var clearP_vc = "AnchorMenu-module--clearP_vc--76116";
export var linkWrapper = "AnchorMenu-module--linkWrapper--03c76";
export var mobileMenu = "AnchorMenu-module--mobileMenu--8573d";
export var link = "AnchorMenu-module--link--7cc85";
export var current = "AnchorMenu-module--current--67239";
export var fadeInAnimation = "AnchorMenu-module--fadeInAnimation--3b5f6";
export var placeHolderShimmer = "AnchorMenu-module--placeHolderShimmer--3eaa1";